import { SelectionTeamActionType } from "../Constants/SelectionTeamActionType";

const initialState = {
	teams: [],
};

export const SelectionReducers = (state = initialState, action) => {
	switch (action.type) {
		case SelectionTeamActionType.SET_SELECTED_TEAMS:
			return {
				...state,
				teams: action.payload,
			};
		default:
			return state;
	}

};
